import { U21Form, U21Modal } from 'app/shared/u21-ui/components';
import { IconBookmark } from '@u21/tabler-icons';

import {
  Filter,
  FilterContext,
  SavedFilter,
  SaveFilterFormValues,
} from 'app/modules/filters/models';
import { useCreateSavedFilter } from 'app/modules/filters/queries/useCreateSavedFilter';
import { SaveFilterFormContent } from 'app/modules/filters/components/SaveFilterFormContent';
import { SHARING_PRIVATE, SHARING_TEAMS } from 'app/modules/filters/constants';

const FORM_ID = 'save-filter-form';

interface Props {
  filterContext: FilterContext;
  filters: Filter[];
  onClose: () => void;
  onSaved?: (savedFilter: SavedFilter) => void;
  open: boolean;
}

export const CreateSavedFilterModal = ({
  filterContext,
  filters,
  onClose,
  onSaved,
  open,
}: Props) => {
  const { isPending, mutateAsync: createSavedFilter } = useCreateSavedFilter();

  return (
    <U21Modal
      title="Save Filter"
      titleIcon={<IconBookmark />}
      open={open}
      onClose={onClose}
      actionButtonProps={{
        children: 'Save Filter',
        type: 'submit',
        form: FORM_ID,
        loading: isPending,
      }}
    >
      <U21Form<SaveFilterFormValues>
        id={FORM_ID}
        prompt={false}
        initialValues={{ sharing: SHARING_PRIVATE, team_ids: [] }}
        onSubmit={async (values) => {
          try {
            const saved = await createSavedFilter({
              title: values.title,
              description: values.description,
              filter_context: filterContext,
              filters,
              team_ids: values.sharing === SHARING_TEAMS ? values.team_ids : [],
            });
            onSaved?.(saved);
            onClose();
          } catch {}
        }}
      >
        <SaveFilterFormContent />
      </U21Form>
    </U21Modal>
  );
};
